<template>
  <th>
    <a v-on:click="click" v-bind:title="title">{{ fieldCapitalized }}</a>
    <span class="icon is-small">
      <font-awesome-icon v-show="showIcon" v-bind:icon="icon" />
    </span>
  </th>
</template>

<script>
export default {
  name: 'CotizrColumnHeader',
  props: {
    field: String,
    onSort: Function,
    showIcon: Boolean
  },
  data: function () {
    return {
      reverse: false
    }
  },
  methods: {
    click: function (field) {
      this.reverse = !this.reverse
      this.onSort(this.field, this.reverse)
    }
  },
  computed: {
    fieldCapitalized: function () {
      return this.field.charAt(0).toUpperCase() + this.field.slice(1)
    },
    icon: function () {
      return this.reverse ? 'caret-down' : 'caret-up'
    },
    title: function () {
      return `Ordenar por ${this.field}`
    }
  }
}
</script>

<style lang="scss">
</style>
